const ALLOWED_CODES = new Set(["EJRI", "EJTI", "EJDEV", "EJTU", "EJME"]);

const ABBREV_TO_CODE = new Map([
	["EJRI", "EJRI"],
	["EJTI", "EJTI"],
	["EJDEV", "EJDEV"],
	["EJ-DEVELOPPER", "EJDEV"],
	["EJTU", "EJTU"],
	["EJ-TURNI", "EJTU"],
	["EJ-TIMBRATORE", "EJTI"],
	["EJ-RICHIESTE", "EJRI"],
	["EJ-REQUEST", "EJRI"],
	["EJ-DEV", "EJDEV"],
	["EJ DEVELOP", "EJDEV"],
	["EJME", "EJME"],
	["EJ-MESSAGGI", "EJME"],
	["EJ-MESSAGES", "EJME"],
]);

function canonicalizeCode(raw) {
	if (!raw) return null;
	const upper = String(raw).trim().toUpperCase();
	if (!upper) return null;
	if (upper === "EJME" || upper.startsWith("EJ-ME") || upper === "EJ-MESSAGGI") return "EJME"; //Messaggi
	if (upper === "EJDEV" || upper.startsWith("EJ-DEV")) return "EJDEV"; //Sviluppo
	if (upper === "EJTI" || upper.startsWith("EJ-TI")) return "EJTI"; //Timbratore
	if (upper === "EJRI" || upper === "EJR" || upper.startsWith("EJ-RI")) return "EJRI"; //Richieste
	if (upper === "EJTU" || upper.startsWith("EJ-TU"))  return "EJTU"; //Turni
	if (upper === "EJT") return "EJTI"; //Timbratore (codice corto Cedolino)
	const mapped = ABBREV_TO_CODE.get(upper);
	if (mapped) return mapped;
	return null;
}

export function normalizePermessi(rawPermessi) {
	const normalizeValue = (value) => {
		if (!value) return null;
		if (typeof value === "string") {
			return canonicalizeCode(value);
		}
		if (typeof value === "object") {
			return canonicalizeCode(value.sezione_codice);
		}
		return null;
	};

	if (!rawPermessi || (Array.isArray(rawPermessi) && rawPermessi.length === 0)) return [];
	if (Array.isArray(rawPermessi)) {
		return Array.from(
			new Set(
				rawPermessi
					.map(normalizeValue)
					.filter(code => code && ALLOWED_CODES.has(code))
			)
		);
	}
	if (typeof rawPermessi === "string") {
		return Array.from(
			new Set(
				rawPermessi
					.split(/[,;\s]+/)
					.map(normalizeValue)
					.filter(code => code && ALLOWED_CODES.has(code))
			)
		);
	}
	return [];
}

export function hasPrivilegeFromList(normalizedList, code) {
	if (!code) return false;
	if (!normalizedList || normalizedList.length === 0) return false;
	return normalizedList.includes(code.toUpperCase());
}

export function hasPrivilege(rawPermessi, code) {
	const normalized = normalizePermessi(rawPermessi);
	return hasPrivilegeFromList(normalized, code);
}
